<template>
  <div class="col-sm-12">
    <span>
      <button class="btn btn-success btn-sm" type="button" @click="loadEmployeeAbsences(employee, 'vacations')" data-bs-toggle="modal" data-bs-target=".employee-absence-modal" style="float: right; height: 35px;">Registrar Vacaciones</button>
    </span>
    <select class="form-select" v-model="periodSelect" style="float: right; margin-right: 10px; width: 200px; height: 35px;" @change="changeFilters">
        <option v-for="period in periods" :value="period.id">{{ period.name }}</option>
    </select>
    <br /><br /><br />
    <div class="card">
      <div style="overflow-x: auto; max-width: 100%;">
        <table class="table">
          <tbody v-if="!vacations || vacations.length == 0">
            <tr>
              <td class="sticky-col" colspan="4" style="text-align: center;"><br />NO EXISTEN REGISTROS DE VACACIONES<br /><br /></td>
            </tr>
          </tbody>
          <thead v-if="vacations && vacations.length > 0">
            <tr class="border-bottom-danger header">
              <th class="sticky-col">Fecha</th>
              <th class="sticky-col" scope="col">Descripción</th>
              <th class="sticky-col" scope="col">Días</th>
              <th class="sticky-col" scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="vacations && vacations.length > 0">
            <tr :class="index % 2 == 0 ? 'border-bottom-warning' : 'border-bottom-danger'" v-for="(vacation, index) in vacations" :key="index">
              <td class="sticky-col">{{ $formatDate(vacation.date+"") }}</td>
              <td class="sticky-col">{{ vacation.observations }}</td>
              <td class="sticky-col">{{ vacation.type == 'plus' ? vacation.days : (vacation.days > 0 ? vacation.days * -1 : vacation.days) }} {{Math.abs(vacation.days) > 1 ? 'días' : 'día'}}</td>
              <th class="money" scope="col">
                <button v-if="vacation.type == 'minus'" class="btn btn-primary btn-sm"@click="loadDeleteVacations(vacation)" type="button" style="float: right; width: 120px;" title="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target=".employee-delete-vacations-modal">Eliminar</button>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer"></div>
    </div>
    <div class="modal fade employee-absence-modal" tabindex="-1" role="dialog" aria-labelledby="absenceEmployeeModalLabel" aria-hidden="true">
        <EmployeeAbsenceModal ref="employeeAbsenceModal" :employees="employees" @refresh="refreshEmployees" />
    </div>
    <div class="modal fade employee-delete-vacations-modal" tabindex="-1" role="dialog" aria-labelledby="deleteVacationsEmployeeModalLabel" aria-hidden="true">
        <DeleteVacationsModal ref="deleteVacationsModal" @refresh="changeFilters" />
    </div>  
  </div>
</template>
<script>
import { mapState } from 'vuex';
import getImage from "@/mixins/getImage"

import EmployeeAbsenceModal from "@/components/tmkt/employees/employee_absence_modal.vue"
import DeleteVacationsModal from "@/components/tmkt/employees/employee_delete_vacations_modal.vue"

import ws from '@/services/employees'

export default {
  components: {
    EmployeeAbsenceModal,
    DeleteVacationsModal
  },
  mixins: [getImage],
  data(){
      return{
          periods: [],
          periodSelect: "202405",
          lastPeriod: "202405",
          vacations: null,
          employee: null,
          employees: null
      }
  },
  mounted: async function() {
      // let response = await ws.getMonthPeriods(); 

      // if(response.type == "success"){
      //     this.periods = response.data;

      //     this.periodSelect = this.periods[0].id;
      // }
  },
  methods: {
    async changeFilters () {
      let flag = false;

      if(this.lastPeriod != this.periodSelect){
        flag = true;

        this.lastPeriod = this.periodSelect;
      }

      let filters = {
        period : this.periodSelect,
        employee_id: this.employee.id
      };

      let response = await ws.getVacations(filters);

      if(response.type == "success"){
        let data = response.data;
        this.vacations = data.vacations;

        this.$emit('refresh', data)
      }

      let filters2 = {
        period : this.periodSelect,
        employer_id: this.employee.employer_id
      };

      let response2 = await ws.getEmployeesFilteredWithPayroll(filters2);

      if(response2.type == "success"){
        this.employees = response2.data;
      }
    },
     async loadEmployee (employee) {
      this.employee = employee;

      let response = await ws.getEmployeePeriods(employee.initial_date); 

      if(response.type == "success"){
          this.periods = response.data;

          this.periodSelect = this.periods[0].id;
      }

      this.changeFilters();
    },
    async loadEmployeeAbsences (employee, type) {
      this.$refs.employeeAbsenceModal.loadEmployee(employee, type);
    },
    async loadDeleteVacations (vacation) {
      this.$refs.deleteVacationsModal.loadEmployee(this.employee, vacation, this.periodSelect);
    },
    async refreshEmployees () {
      let filters = {
        period : this.periodSelect,
        employer_id: this.employerSelect,
        fiscal_salary: true
      };

      let response = await ws.getEmployeesFilteredWithPayroll(filters);

      if(response.type == "success"){
        this.employees = response.data;

        this.$refs.employeeAbsenceModal.clearForm();
      }
    },
  },  
  computed: {
    ...mapState({
      bootstraplist: state => state.bootsrap.bootstrap,
      inverselist: state => state.bootsrap.inverse
    })
  },
}
</script>
<style>
  .table{
    td{
      vertical-align: middle;
    }
    
    .money{
      text-align: right;
    }

    .center{
      text-align: center;
    }
  }

  .table-responsive {
    overflow-x: auto;
    max-width: 100%;
  }

  .table-responsive .table {
    min-width: 1000px; /* o el valor que necesites para evitar columnas apretadas */
    border-collapse: collapse;
  }

  .table th,
  .table td {
    padding: 8px 12px;
    white-space: nowrap; /* Evita que el texto se rompa */
  }

  .sticky-col {
    position: sticky;
    left: 0;
    background-color: #F9F9F9 !important; /* o el color de fondo que tengas */
    z-index: 2;
  }
</style>